export default __webpack_public_path__ + "static/media/scheme-block.802089ed.svg";